import React, { FC } from 'react';
import { Global } from '@emotion/react';
import { useBootstrapData, withBootstrapData } from './bootstrap';

export const globalStyles = (staticUrl = '') => `
    @font-face {
        font-family: 'Brandon';
        src: url('${staticUrl}/common/font/BrandonGrotesque-Bold.eot');
        src: url('${staticUrl}/common/font/BrandonGrotesque-Bold.eot?#iefix') format('embedded-opentype'),
            url('${staticUrl}/common/font/BrandonGrotesque-Bold.woff2') format('woff2'),
            url('${staticUrl}/common/font/BrandonGrotesque-Bold.woff') format('woff'),
            url('${staticUrl}/common/font/BrandonGrotesque-Bold.ttf') format('truetype');
        font-weight: bold;
    }

    @font-face {
        font-family: 'Brandon';
        src: url('${staticUrl}/common/font/BrandonText-Regular.eot');
        src: url('${staticUrl}/common/font/BrandonText-Regular.eot?#iefix') format('embedded-opentype'),
            url('${staticUrl}/common/font/BrandonText-Regular.woff2') format('woff2'),
            url('${staticUrl}/common/font/BrandonText-Regular.woff') format('woff'),
            url('${staticUrl}/common/font/BrandonText-Regular.ttf') format('truetype');
        font-weight: normal;
    }

    @font-face {
        font-family: 'Freeland';
        src: url('${staticUrl}/common/font/Freeland.eot');
        src: url('${staticUrl}/common/font/Freeland.eot?#iefix') format('embedded-opentype'),
            url('${staticUrl}/common/font/Freeland.woff2') format('woff2'),
            url('${staticUrl}/common/font/Freeland.woff') format('woff'),
            url('${staticUrl}/common/font/Freeland.ttf') format('truetype');
    }

    @font-face {
        font-family: open-sans;
        src: url('${staticUrl}/common/font/OpenSans-Regular.eot');
        src: url('${staticUrl}/common/font/OpenSans-Regular.eot?#iefix') format('embedded-opentype'),
            url('${staticUrl}/common/font/OpenSans-Regular.woff2') format('woff2'),
            url('${staticUrl}/common/font/OpenSans-Regular.woff') format('woff'),
            url('${staticUrl}/common/font/OpenSans-Regular.ttf') format('truetype');
    }

    @font-face {
        font-family: open-sans;
        font-weight: 600;
        src: url('${staticUrl}/common/font/OpenSans-SemiBold.eot');
        src: url('${staticUrl}/common/font/OpenSans-SemiBold.eot?#iefix') format('embedded-opentype'),
            url('${staticUrl}/common/font/OpenSans-SemiBold.woff2') format('woff2'),
            url('${staticUrl}/common/font/OpenSans-SemiBold.woff') format('woff'),
            url('${staticUrl}/common/font/OpenSans-SemiBold.ttf') format('truetype');
    }

    @font-face {
        font-family: open-sans;
        font-weight: 700;
        src: url('${staticUrl}/common/font/OpenSans-Bold.eot');
        src: url('${staticUrl}/common/font/OpenSans-Bold.eot?#iefix') format('embedded-opentype'),
            url('${staticUrl}/common/font/OpenSans-Bold.woff2') format('woff2'),
            url('${staticUrl}/common/font/OpenSans-Bold.woff') format('woff'),
            url('${staticUrl}/common/font/OpenSans-Bold.ttf') format('truetype');
    }

    @font-face {
        font-family: 'ProximaNova';
        src: url('${staticUrl}/common/font/ProximaNova-Regular.eot');
        src: url('${staticUrl}/common/font/ProximaNova-Regular.eot?#iefix') format('embedded-opentype'),
            url('${staticUrl}/common/font/ProximaNova-Regular.woff2') format('woff2'),
            url('${staticUrl}/common/font/ProximaNova-Regular.woff') format('woff'),
            url('${staticUrl}/common/font/ProximaNova-Regular.ttf') format('truetype');
        font-weight: normal;
    }

    @font-face {
        font-family: 'ProximaNova';
        src: url('${staticUrl}/common/font/ProximaNova-Bold.eot');
        src: url('${staticUrl}/common/font/ProximaNova-Bold.eot?#iefix') format('embedded-opentype'),
            url('${staticUrl}/common/font/ProximaNova-Bold.woff2') format('woff2'),
            url('${staticUrl}/common/font/ProximaNova-Bold.woff') format('woff'),
            url('${staticUrl}/common/font/ProximaNova-Bold.ttf') format('truetype');
        font-weight: bold;
    }

    @font-face {
        font-family: 'bambusa-pro-regular';
        src: url('${staticUrl}/common/font/BambusaPro_Regular.eot');
        src: url('${staticUrl}/common/font/BambusaPro_Regular.eot#iefix') format('embedded-opentype'),
            url('${staticUrl}/common/font/BambusaPro_Regular.woff') format('woff'),
            url('${staticUrl}/common/font/BambusaPro_Regular.woff2') format('woff2'),
            url('${staticUrl}/common/font/BambusaPro_Regular.ttf') format('truetype');
        font-weight: normal;
    }

    @font-face {
        font-family: 'scandiebox-one';
        src: url('${staticUrl}/common/font/SBOne-Regular.eot');
        src: url('${staticUrl}/common/font/SBOne-Regular.eot#iefix') format('embedded-opentype'),
            url('${staticUrl}/common/font/SBOne-Regular.woff') format('woff'),
            url('${staticUrl}/common/font/SBOne-Regular.woff2') format('woff2'),
            url('${staticUrl}/common/font/SBOne-Regular.ttf') format('truetype');
    }

    @font-face {
        font-family: 'blooming-elegant';
        src: url('${staticUrl}/common/font/BloomingElegant-Regular.eot');
        src: url('${staticUrl}/common/font/BloomingElegant-Regular.eot#iefix') format('embedded-opentype'),
            url('${staticUrl}/common/font/BloomingElegant-Regular.woff') format('woff'),
            url('${staticUrl}/common/font/BloomingElegant-Regular.woff2') format('woff2'),
            url('${staticUrl}/common/font/BloomingElegant-Regular.ttf') format('truetype');
    }

    @keyframes shift-left-by-half {
        0% {
            transform: translate3d(0, 0, 0);
        }

        100% {
            transform: translate3d(-50%, 0, 0);
        }
    }

    /* Google Fonts - Regular weights only (matching actual font files) */
    @font-face {
        font-family: 'Roboto';
        src: url('${staticUrl}/common/font/Roboto-Regular.woff2') format('woff2');
        font-weight: 400;
        font-display: swap;
    }

    @font-face {
        font-family: 'Lato';
        src: url('${staticUrl}/common/font/Lato-Regular.woff2') format('woff2');
        font-weight: 400;
        font-display: swap;
    }

    @font-face {
        font-family: 'Spectral';
        src: url('${staticUrl}/common/font/Spectral-Regular.woff2') format('woff2');
        font-weight: 400;
        font-display: swap;
    }

    @font-face {
        font-family: 'Montserrat';
        src: url('${staticUrl}/common/font/Montserrat-Regular.woff2') format('woff2');
        font-weight: 400;
        font-display: swap;
    }

    @font-face {
        font-family: 'Oswald';
        src: url('${staticUrl}/common/font/Oswald-Regular.woff2') format('woff2');
        font-weight: 400;
        font-display: swap;
    }

    @font-face {
        font-family: 'Quicksand';
        src: url('${staticUrl}/common/font/Quicksand-Regular.woff2') format('woff2');
        font-weight: 400;
        font-display: swap;
    }

    @font-face {
        font-family: 'Raleway';
        src: url('${staticUrl}/common/font/Raleway-Regular.woff2') format('woff2');
        font-weight: 400;
        font-display: swap;
    }

    @font-face {
        font-family: 'Inter';
        src: url('${staticUrl}/common/font/Inter-Regular.woff2') format('woff2');
        font-weight: 400;
        font-display: swap;
    }

    @font-face {
        font-family: 'Playfair Display';
        src: url('${staticUrl}/common/font/PlayfairDisplay-Regular.woff2') format('woff2');
        font-weight: 400;
        font-display: swap;
    }

    @font-face {
        font-family: 'PT Sans';
        src: url('${staticUrl}/common/font/PTSans-Regular.woff2') format('woff2');
        font-weight: 400;
        font-display: swap;
    }

    @font-face {
        font-family: 'Red Hat Display';
        src: url('${staticUrl}/common/font/RedHatDisplay-Regular.woff2') format('woff2');
        font-weight: 400;
        font-display: swap;
    }

    @font-face {
        font-family: 'Merriweather';
        src: url('${staticUrl}/common/font/Merriweather-Regular.woff2') format('woff2');
        font-weight: 400;
        font-display: swap;
    }

    @font-face {
        font-family: 'Figtree';
        src: url('${staticUrl}/common/font/Figtree-Regular.woff2') format('woff2');
        font-weight: 400;
        font-display: swap;
    }

    @font-face {
        font-family: 'Palanquin';
        src: url('${staticUrl}/common/font/Palanquin-Regular.woff2') format('woff2');
        font-weight: 400;
        font-display: swap;
    }

    @font-face {
        font-family: 'Slabo 27px';
        src: url('${staticUrl}/common/font/Slabo27px-Regular.woff2') format('woff2');
        font-weight: 400;
        font-display: swap;
    }

    @font-face {
        font-family: 'Sora';
        src: url('${staticUrl}/common/font/Sora-Regular.woff2') format('woff2');
        font-weight: 400;
        font-display: swap;
    }

    @font-face {
        font-family: 'Cabin';
        src: url('${staticUrl}/common/font/Cabin-Regular.woff2') format('woff2');
        font-weight: 400;
        font-display: swap;
    }

    @font-face {
        font-family: 'Cormorant Garamond';
        src: url('${staticUrl}/common/font/CormorantGaramond-Regular.woff2') format('woff2');
        font-weight: 400;
        font-display: swap;
    }

    @font-face {
        font-family: 'Caveat';
        src: url('${staticUrl}/common/font/Caveat-Regular.woff2') format('woff2');
        font-weight: 400;
        font-display: swap;
    }

    @font-face {
        font-family: 'Shadows Into Light';
        src: url('${staticUrl}/common/font/ShadowsIntoLight-Regular.woff2') format('woff2');
        font-weight: 400;
        font-display: swap;
    }

    @font-face {
        font-family: 'Reenie Beanie';
        src: url('${staticUrl}/common/font/ReenieBeanie-Regular.woff2') format('woff2');
        font-weight: 400;
        font-display: swap;
    }

    @font-face {
        font-family: 'Bilbo Swash Caps';
        src: url('${staticUrl}/common/font/BilboSwashCaps-Regular.woff2') format('woff2');
        font-weight: 400;
        font-display: swap;
    }

    @font-face {
        font-family: 'Indie Flower';
        src: url('${staticUrl}/common/font/IndieFlower-Regular.woff2') format('woff2');
        font-weight: 400;
        font-display: swap;
    }

    @font-face {
        font-family: 'Dancing Script';
        src: url('${staticUrl}/common/font/DancingScript-Regular.woff2') format('woff2');
        font-weight: 400;
        font-display: swap;
    }

    @font-face {
        font-family: 'Urbanist';
        src: url('${staticUrl}/common/font/Urbanist-Regular.woff2') format('woff2');
        font-weight: 400;
        font-display: swap;
    }

    @font-face {
        font-family: 'Barlow Semi Condensed';
        src: url('${staticUrl}/common/font/BarlowSemiCondensed-Regular.woff2') format('woff2');
        font-weight: 400;
        font-display: swap;
    }

    @font-face {
        font-family: 'Bebas Neue';
        src: url('${staticUrl}/common/font/BebasNeue-Regular.woff2') format('woff2');
        font-weight: 400;
        font-display: swap;
    }

    @font-face {
        font-family: 'Lora';
        src: url('${staticUrl}/common/font/Lora-Regular.woff2') format('woff2');
        font-weight: 400;
        font-display: swap;
    }
`;

export const GlobalStyles: FC = withBootstrapData(() => {
    const { staticUrl } = useBootstrapData();

    return <Global styles={globalStyles(staticUrl)} />;
});
